/* eslint-disable react/jsx-handler-names */

import React from 'react';
import {Link} from 'react-router-dom';
import {MobileView} from 'react-device-detect';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
// import Lock from '@material-ui/icons/Lock';
import LockOpen from '@material-ui/icons/LockOpen';
import List from '@material-ui/icons/List';
import Home from '@material-ui/icons/Home';
import Info from '@material-ui/icons/Info';
import BorderVertical from '@material-ui/icons/BorderVertical';
//import Settings from '@material-ui/icons/Settings';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};





function MenuPopupState(props) {
  const { classes } = props;
  
  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {popupState => (
        <React.Fragment>
          <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" {...bindTrigger(popupState)}>
            <MenuIcon />
          </IconButton>
          <Menu {...bindMenu(popupState)}>
           <MenuItem onClick={popupState.close} component={Link} to="/"><Home /> Main Menu</MenuItem>
           <MobileView>
              <MenuItem onClick={popupState.close} component={Link} to="CodeScan"><BorderVertical />&nbsp;QR Code Scan </MenuItem>
           </MobileView>           
           <MenuItem onClick={popupState.close} component={Link} to="TempCodeRqst"><LockOpen /> Temp Code</MenuItem> 
           <MenuItem onClick={popupState.close} component={Link} to="OpenCloseCodes"><List /> Open/Close Codes</MenuItem>                     
           <MenuItem onClick={popupState.close} component={Link} to="About"><Info /> About</MenuItem>           
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
}
export default withStyles(styles)(MenuPopupState);



// WEBPACK FOOTER //
// ./src/components/MenuItems.jsx